/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, June 23rd 2022, 11:50:49 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { URLS } from "core/routes";
import { FullScreenNotificationGrid, OSActionButton } from "ui-widgets";
import { BugReportIcon } from "theme/icons";

export const ErrorFallback = () => {
  return (
    <>
      <div className="first-side-bar">
        <div className="first-sidebar-in"></div>
      </div>
      <FullScreenNotificationGrid
        pageTitle={<>Well, this is embarassing. An application error has occurred</>}
        pageContent={
          <>
            <p>
              We are really sorry about this. Something went wrong and we are working on fixing it. To continue using
              the application, please click on the dashboard button below.
            </p>
            <p>You can also opt to help us fast track this bug fix by reporting the bug.</p>
            <Stack direction="row" spacing={2} justifyContent="center">
              <OSActionButton variant="contained" href={URLS.dashboard}>
                Go to dashboard
              </OSActionButton>
              <OSActionButton color="warning" variant="contained" href="mailto:support@otbafrica.com">
                Report this bug
              </OSActionButton>
            </Stack>
          </>
        }
        pageIllustration={<BugReportIcon height={256} width={256} />}
      />
    </>
  );
};
